<template>
  <PmDefaultViewsPure
    :views="normalizedViews"
    :state="state.path.value"
    :error-message="state.snapshot.context.error"
    :error-details="state.snapshot.context.errorDetails"
    :initial-form-data="initialFormData"
    @submit="(payload) => state.send({ type: 'submit', variables: payload })"
  />
</template>

<script setup lang="ts">
import { useStore } from 'vuex'
import { computed } from 'vue'
import { PmDefaultViewsState } from '@/components/PmDefaultViews/PmDefaultViewsState'
import { fromPromise } from 'xstate5'
import { useXState } from '@/composition/useXState5'
import PmDefaultViewsPure, {
  type Props as PropsDefaultViewsPure,
} from '@/components/PmDefaultViews/PmDefaultViewsPure.vue'
import { useQuery } from '@vue/apollo-composable'
import { ViewsDocument } from '../../../generated/graphql'
import { useUserSettings } from '@/composition/useUserSettings'

const state = useXState(
  PmDefaultViewsState.provide({
    actors: {
      save: fromPromise(async ({ input }) =>
        userSettings.save({
          'view.defaultSavedViewIdMobile': input.variables.viewIdMobile,
          'view.defaultSavedViewIdDesktop': input.variables.viewIdDesktop,
        })
      ),
    },

    actions: {
      showSuccessNotification: () => {
        store.commit('notification/add', {
          variant: 'success',
          title: 'Die Standard-Ansichten wurden erfolgreich gespeichert',
        })
      },
    },
  })
)

const userSettings = useUserSettings()
const store = useStore()

const viewsQuery = useQuery(ViewsDocument)
const views = computed(() => viewsQuery.result.value?.views)

const initialFormData = {
  selectedViewIdMobile: store.state.view.defaultSavedViewIdMobile,
  selectedViewIdDesktop: store.state.view.defaultSavedViewIdDesktop,
}

const normalizedViews = computed(() => {
  if (!views.value) return
  const result: PropsDefaultViewsPure['views'] = []

  views.value.forEach((view) => {
    if (!view) return

    result.push({
      id: view.id,
      label: view.title,
      icon: view.public ? 'public' : undefined,
      iconTitle: view.public ? 'Öffentlich' : undefined,
    })
  })

  return result
})
</script>
